import * as React from 'react';

import {CancelButton} from '../../../button/cancel-button/cancel-button';
import {CheckmarkButton} from '../../../button/checkmark-button/checkmark-button';
import {getMentionsConfig} from '../../../rich-textarea/get-mentions-config';
import {isRichTextareaEmpty} from '../../../rich-textarea/helpers';
import {RichTextarea} from '../../../rich-textarea/rich-textarea';

import {useGetTeams} from '../../../../../../../ui/core/graphql/hooks';

import styles from './add-a-comment.module.css';

type Props = {
    onAddComment: (value: string) => Promise<any>;
    cancelAddingComment?: () => void;
    isAddingComment?: boolean;
};

export function AddAComment(props: Props) {
    // The value to save to the database, without the rendered HTML @mention content
    const [commentPlaintextValue, setCommentPlaintextValue] = React.useState<string>('');
    // The HTML value of the comment
    const [commentHtmlValue, setCommentHtmlValue] = React.useState<string>('');

    const isCommentEmpty = isRichTextareaEmpty(commentHtmlValue, commentPlaintextValue);

    const onAddComment = () => {
        if (!isCommentEmpty) {
            props.onAddComment(commentPlaintextValue);
            setCommentHtmlValue('');
            setCommentPlaintextValue('');
        }
    };

    const onCancelComment = () => {
        if (props.cancelAddingComment) {
            props.cancelAddingComment();
        }
        setCommentHtmlValue('');
        setCommentPlaintextValue('');
    };

    // @ts-expect-error
    const handleChange = (newValue, textValue) => {
        setCommentHtmlValue(newValue);
        setCommentPlaintextValue(textValue);
    };

    const {teams} = useGetTeams();

    return (
        <form className={styles['add-a-comment']}>
            <div className={styles['textarea']}>
                <RichTextarea
                    id='timeline-comment'
                    isFullHeight={true}
                    overflowVisible={true}
                    placeholder='Write a comment…'
                    value={commentHtmlValue}
                    config={{
                        modules: {
                            toolbar: false,
                        },
                        formats: ['bold', 'italic', 'mention'],
                        images: false,
                        formatLinks: true,
                        useDivs: false,
                        placeholders: false,
                        mention: getMentionsConfig(),
                    }}
                    forceFocus={props.isAddingComment}
                    onBlur={() => {
                        // If comment is empty and user clicks off input, treat as cancelled comment
                        if (isCommentEmpty) {
                            onCancelComment();
                        }
                    }}
                    onEnter={() => {
                        onAddComment();
                    }}
                    onChange={handleChange}
                    teams={teams}
                    fixPlaceholderPosition={true}
                />
            </div>
            {commentPlaintextValue.length ? (
                <div className={styles['button-container']}>
                    <CheckmarkButton onClick={onAddComment} isDisabled={isCommentEmpty} />
                    <CancelButton onClick={onCancelComment} />
                </div>
            ) : undefined}
        </form>
    );
}
